import React from 'react';
import {
    BoundarySign,
    exactOrBoundarySigns,
    ExactSign,
    isBoundarySign,
    isExactSign,
} from 'utils/filter/filter';
import ComparisonControl from 'utils/components/FiltersModal/comparison/ComparisonControl';
import {
    BoundaryComparison,
    ExactComparison,
    SupportedComparisonValue,
} from 'utils/components/FiltersModal/comparison/FilterComparison';
import { EnumMap } from '@instinet-analytics/core-lib';
import { ValueType } from '@instinet-analytics/semantic-ui-components';

interface FirstComparisonControlProps {
    columnName?: string;
    enumMap?: EnumMap;
    comparison: ExactComparison | BoundaryComparison;
    onSignBecomeExact: (sign: ExactSign) => void;
    onSignBecomeBoundary: (sign: BoundarySign) => void;
    onValueChange: (value: SupportedComparisonValue) => void;
    onInputEnter: () => void;
}

export default function FirstComparisonControl(
    props: FirstComparisonControlProps
) {
    const {
        columnName,
        comparison,
        onSignBecomeExact,
        onSignBecomeBoundary,
        onValueChange,
        enumMap,
        onInputEnter,
    } = props;

    function getAvailableSigns(
        comparison: ExactComparison | BoundaryComparison
    ) {
        switch (comparison.valueType) {
            case ValueType.NUMBER:
            case ValueType.DATE:
            case ValueType.TIME:
            case ValueType.DATETIME:
                return [...exactOrBoundarySigns];
            default:
                return [ExactSign.EQ, ExactSign.NEQ];
        }
    }

    return (
        <ComparisonControl
            columnName={columnName}
            availableSigns={getAvailableSigns(comparison)}
            enumMap={enumMap}
            valueType={comparison.valueType}
            sign={comparison.sign}
            value={comparison.value}
            isExactOrFirstInRange={true}
            onSignChange={(sign) => {
                if (isExactSign(sign)) {
                    onSignBecomeExact(sign);
                } else if (isBoundarySign(sign)) {
                    onSignBecomeBoundary(sign);
                }
            }}
            onValueChange={onValueChange}
            onInputEnter={onInputEnter}
        />
    );
}
